exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.abnormal-notification {\n    background: #FFF2E8 !important;\n    border: 2px solid #FFD8BF !important;\n    width: max-content !important;\n}\n.abnormal-notification .abnormal-no {\n    color: #FA541C !important;\n    text-decoration: underline !important;\n    cursor: pointer !important;\n}\n.abnormal-notification span {\n    color: black !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-1480ba57","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 1105
// module chunks = 159